module.exports = __webpack_public_path__ + "assets/45dda5551e5f36164eadc32d193184b4.png";